import * as $ from 'jquery';
import { apiBaseUrlUser } from "../../../constants/url.constant";
import { DefaultService } from "../../common/services/DefaultService";
import { NewPaymentModel } from "../models/PaymentModels";

export class PaymentService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/payment`;

    public RouteGet = (id: string) => `${this.baseUrl}/get/${id}`;
    public get(id: string): JQueryPromise<any> {
        return $.ajax(this.RouteGet(id), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGetList = () => `${this.baseUrl}/getList`;
    public getList(): JQueryPromise<any> {
        return $.ajax(this.RouteGetList(), {
            type: 'get',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteGetPaidInvoice = (id: string) => `${this.baseUrl}/getPaidInvoice/${id}`;
    public getPaidInvoice(id: string): JQueryPromise<any> {
        return $.ajax(this.RouteGetPaidInvoice(id), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteCreate = () => `${this.baseUrl}/create`;
    public create(model: NewPaymentModel): JQueryPromise<any> {
        return $.ajax(this.RouteCreate(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteDelete = (id: string) => `${this.baseUrl}/delete/${id}`;
    public delete(id: string): JQueryPromise<any> {
        return $.ajax(this.RouteDelete(id), {
            type: 'delete',
            contentType: 'application/json'
        });
    }

    public RouteGetPictures = (ownerId: string) => `${this.baseUrl}/getPictures/${ownerId}`;
    public getPictures(ownerId: string): JQueryPromise<any> {
        return $.ajax(this.RouteGetPictures(ownerId), {
            type: 'get',
            data: undefined,
            contentType: 'application/json'
        });
    }

    public RouteGetPictureBytes = (ownerId: string, id: number) =>
        `${this.baseUrl}/getPictures/${ownerId}?id=${id}`;

    public getPictureBytes(ownerId: string, id: number): JQueryPromise<any> {
        return $.ajax(this.RouteGetPictureBytes(ownerId, id), {
            type: 'get',
            data: undefined,
            contentType: 'application/json'
        });
    }
}